const UsermanagementConstants = {
  GET_USERS_SUCESS: "GET_USERS_SUCESS",
  GET_USERS_FAILURE: "GET_USERS_FAILURE",

  GET_USER_DETAILS_SUCCESS: "GET_USER_DETAILS_SUCCESS",
  GET_USER_DETAILS_FAILURE: "GET_USER_DETAILS_FAILURE",

  ADDORUPDATE_USER_SUCCESS: "ADDORUPDATE_USER_SUCCESS",
  ADDORUPDATE_USER_FAILURE: "ADDORUPDATE_USER_FAILURE",

  ADDORUPDATE_ORGANISATION_SUCCESS: "ADDORUPDATE_ORGANISATION_SUCCESS",
  ADDORUPDATE_ORGANISATION_FAILURE: "ADDORUPDATE_ORGANISATION_FAILURE",

  GET_ORGANISATION_SUCCESS: "GET_ORGANISATION_SUCCESS",
  GET_ORGANISATION_FAILURE: "GET_ORGANISATION_FAILURE",

  GET_ORGANISATION_EXPORT_DETAILS_SUCCESS:
    "GET_ORGANISATION_EXPORT_DETAILS_SUCCESS",
  GET_ORGANISATION_EXPORT_DETAILS_FAILURE:
    "GET_ORGANISATION_EXPORT_DETAILS_FAILURE",

  // --------------------- Plant ----------------------
  GET_PLANT_SUCCESS: "GET_PLANT_SUCCESS",
  GET_PLANT_FAILURE: "GET_PLANT_FAILURE",

  GET_ADMIN_OR_PLANT_ADMIN_PLANT_SUCCESS:
    "GET_ADMIN_OR_PLANT_ADMIN_PLANT_SUCCESS",
  GET_ADMIN_OR_PLANT_ADMIN_PLANT_FAILURE:
    "GET_ADMIN_OR_PLANT_ADMIN_PLANT_FAILURE",

  // --------------------- Plant ----------------------

  // --------------------- Cost Center ----------------------
  GET_COST_CENTRE_SUCCESS: "GET_COST_CENTRE_SUCCESS",
  GET_COST_CENTRE_FAILURE: "GET_COST_CENTRE_FAILURE",

  ADDORUPDATE_COST_CENTRE_SUCCESS: "ADDORUPDATE_COST_CENTRE_SUCCESS",
  ADDORUPDATE_COST_CENTRE_FAILURE: "ADDORUPDATE_COST_CENTRE_FAILURE",

  GET_PLANT_COST_CENTER_SUCCESS: "GET_PLANT_COST_CENTER_SUCCESS",
  GET_PLANT_COST_CENTER_FAILURE: "GET_PLANT_COST_CENTER_FAILURE",

  DELETE_COST_CENTER_SUCCESS: "DELETE_COST_CENTER_SUCCESS",
  DELETE_COST_CENTER_FAILURE: "DELETE_COST_CENTER_FAILURE",

  GET_PLANT_COST_CENTER_SUCCESS: "GET_PLANT_COST_CENTER_SUCCESS",
  GET_PLANT_COST_CENTER_FAILURE: "GET_PLANT_COST_CENTER_FAILURE",

  // --------------------- Cost Center ----------------------

  BLOCK_ORGANISATION_SUCCESS: "BLOCK_ORGANISATION_SUCCESS",
  BLOCK_ORGANISATION_FAILURE: "GET_ORGANISATION_FAILURE",

  UNBLOCK_ORGANISATION_SUCCESS: "UNBLOCK_ORGANISATION_SUCCESS",
  UNBLOCK_ORGANISATION_FAILURE: "UNBLOCK_ORGANISATION_FAILURE",

  ADD_ORGANISATION_ADMIN_SUCCESS: "ADD_ORGANISATION_ADMIN_SUCCESS",
  ADD_ORGANISATION_ADMIN_FAILURE: "ADD_ORGANISATION_ADMIN_FAILURE",

  BLOCK_USER_SUCCESS: "BLOCK_USER_SUCCESS",
  BLOCK_USER_FAILURE: "GET_USER_FAILURE",

  UNBLOCK_USER_SUCCESS: "UNBLOCK_USER_SUCCESS",
  UNBLOCK_USER_FAILURE: "UNBLOCK_USER_FAILURE",

  GET_FILTERED_USER_SUCCESS: "GET_FILTERED_USER_SUCCESS",
  GET_FILTERED_USER_FAILURE: "GET_FILTERED_USER_FAILURE",

  GET_ROLE_SUCCESS: "GET_ROLE_SUCCESS",
  GET_ROLE_FAILURE: "GET_ROLE_FAILURE",

  ADDORUPDATE_ROLE_SUCCESS: "ADDORUPDATE_ROLE_SUCCESS",
  ADDORUPDATE_ROLE_FAILURE: "ADDORUPDATE_ROLE_FAILURE",

  GET_USER_ROLE_SUCCESS: "GET_USER_ROLE_SUCCESS",
  GET_USER_ROLE_FAILURE: "GET_USER_ROLE_FAILURE",

  GET_COST_CENTRE_FOR_USER_SUCCESS: "GET_COST_CENTRE_FOR_USER_SUCCESS",
  GET_COST_CENTRE_FOR_USER_FAILURE: "GET_COST_CENTRE_FOR_USER_FAILURE",

  DELETE_ROLE_FOR_USER_SUCCESS: "DELETE_ROLE_FOR_USER_SUCCESS",
  DELETE_ROLE_FOR_USER_FAILURE: "DELETE_ROLE_FOR_USER_FAILURE",

  DELETE_COST_CENTRE_FOR_USER_SUCCESS: "DELETE_COST_CENTRE_FOR_USER_SUCCESS",
  DELETE_COST_CENTRE_FOR_USER_FAILURE: "DELETE_COST_CENTRE_FOR_USER_FAILURE",

  RESET_USER_PASSWORD_SUCCESS: "RESET_USER_PASSWORD_SUCCESS",
  RESET_USER_PASSWORD_FAILURE: "RESET_USER_PASSWORD_FAILURE",

  GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_FAILURE:
    "GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_FAILURE",
  GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_SUCCESS:
    "GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_SUCCESS",
  //   UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  //   UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE'
  GET_PLANT_USER_FAILURE: "GET_PLANT_USER_FAILURE",
  GET_PLANT_USER_SUCCESS: "GET_PLANT_USER_SUCCESS",

  GET_ORG_DOMAN_SUCCESS: "GET_ORG_DOMAN_SUCCESS",
  GET_ORG_DOMAN_FAILURE: "GET_ORG_DOMAN_FAILURE",
  GET_ORG_CONFIG_SUCCESS: "GET_ORG_CONFIG_SUCCESS",
  GET_ORG_CONFIG_FAILURE: "GET_ORG_CONFIG_FAILURE",

  CLONE_ORGANISATION_SUCCESS: "CLONE_ORGANISATION_SUCCESS",
  CLONE_ORGANISATION_FAILURE: "CLONE_ORGANISATION_FAILURE",

  GET_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS:
    "GET_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS",
  GET_EQUIP_GRP_RESPONSIBLE_USER_FAILURE:
    "GET_EQUIP_GRP_RESPONSIBLE_USER_FAILURE",

  GET_EQUIP_GRP_USER_SUCCESS: "GET_EQUIP_GRP_USER_SUCCESS",
  GET_EQUIP_GRP_USER_FAILURE: "GET_EQUIP_GRP_USER_FAILURE",

  ADD_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS:
    "ADD_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS",
  ADD_EQUIP_GRP_RESPONSIBLE_USER_FAILURE:
    "ADD_EQUIP_GRP_RESPONSIBLE_USER_FAILURE",

  DELETE_RESPONSIBLE_USER_SUCCESS: "DELETE_RESPONSIBLE_USER_SUCCESS",
  DELETE_RESPONSIBLE_USER_FAILURE: "DELETE_RESPONSIBLE_USER_FAILURE",

  EXPORT_ORGANISATION_DATA_SUCCESS: "EXPORT_ORGANISATION_DATA_SUCCESS",
  EXPORT_ORGANISATION_DATA_FAILURE: "EXPORT_ORGANISATION_DATA_FAILURE",

  DOWNLOAD_ORGANISATION_DATA_SUCCESS: "DOWNLOAD_ORGANISATION_DATA_SUCCESS",
  DOWNLOAD_ORGANISATION_DATA_FAILURE: "DOWNLOAD_ORGANISATION_DATA_FAILURE",

  EXPORT_ARBEITSMITTELGRUPPEN_SUCCESS: "EXPORT_ARBEITSMITTELGRUPPEN_SUCCESS",
  EXPORT_ARBEITSMITTELGRUPPEN_FAILURE: "EXPORT_ARBEITSMITTELGRUPPEN_FAILURE",

  GET_ARBEITSMITTEL_EXPORT_STATUS_SUCCESS: "GET_ARBEITSMITTEL_EXPORT_STATUS_SUCCESS",
  GET_ARBEITSMITTEL_EXPORT_STATUS_FAILURE: "GET_ARBEITSMITTEL_EXPORT_STATUS_FAILURE",

  DOWNLOAD_ARBEITSMITTEL_EXPORT_SUCCESS: "DOWNLOAD_ARBEITSMITTEL_EXPORT_SUCCESS",
  DOWNLOAD_ARBEITSMITTEL_EXPORT_FAILURE: "DOWNLOAD_ARBEITSMITTEL_EXPORT_FAILURE",
};
export default UsermanagementConstants;
